<template>
  <v-container fluid>
    <v-card elevation="1">
      <v-toolbar color="secondary" dark shaped>
        <h3 class="title">{{ $route.name }}</h3>
      </v-toolbar>
      <v-card-text style="padding: 10px">
        <v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  label="Prefeitura:"
                  :rules="fieldRules"
                  :items="prefectures"
                  item-value="prefecture_id"
                  item-text="prefecture_social_name"
                  v-model="data.prefecture_id"
                  @change="selectSecretariats(data.prefecture_id)"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-autocomplete
                  label="Secretaria:"
                  :rules="fieldRules"
                  :items="secretariats"
                  item-value="sec_id"
                  item-text="sec_name"
                  v-model="data.sec_id"
                  @change="selectSubSectors(data.sec_id)"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-autocomplete
                  label="Subsetor:"
                  :items="subsectors"
                  item-value="subsec_id"
                  item-text="subsec_desc"
                  v-model="data.subsec_id"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field label="Placa:" v-model="data.vehicle_board" />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  label="Número do Renavan:"
                  v-model="data.vehicle_renavan"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  label="Código da Unidade Gestora:"
                  v-model="data.vehicle_cod"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  label="Codigo Próprio da Unidade:"
                  v-model="data.vehicle_cod_maquina"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Ano Fabricação:"
                  v-mask="'0000'"
                  v-model="data.vehicle_manufacturing_year"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Ano Modelo:"
                  v-mask="'0000'"
                  v-model="data.vehicle_model_year"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  label="Marca:"
                  :items="brands"
                  item-value="brand_id"
                  :item-text="getBrandText"
                  v-model="data.brand_id"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  label="Modelo:"
                  :items="models"
                  item-value="model_id"
                  :item-text="getModelText"
                  v-model="data.model_id"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  label="Cor:"
                  :items="colors"
                  item-value="color_id"
                  item-text="color_desc"
                  v-model="data.color_id"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  label="Tipo de Combustível:"
                  :rules="fieldRules"
                  :items="fuels"
                  item-value="fuel_id"
                  item-text="fuel_desc"
                  v-model="data.fuel_id"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  label="Tipo de consumo:"
                  :rules="fieldRules"
                  :items="consumption"
                  item-value="consumption_id"
                  item-text="consumption_desc"
                  v-model="data.consumption_id"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Capacidade do tanque:"
                  v-mask-decimal.br="2"
                  v-model="data.vehicle_tank_capacity"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Média de consumo mínima:"
                  v-mask-decimal.br="2"
                  :rules="fieldRules"
                  v-model="data.vehicle_average_consumption_minimum"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Média de consumo máxima:"
                  v-mask-decimal.br="2"
                  :rules="fieldRules"
                  v-model="data.vehicle_average_consumption_maximum"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Consumo litros hora:"
                  v-mask-decimal.br="2"
                  v-model="data.vehicle_consumption_liters_hour"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Quantidade LT:"
                  v-mask-decimal.br="2"
                  v-model="data.vehicle_number_of_liters"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Quantidade valor:"
                  v-mask-decimal.br="2"
                  v-model="data.vehicle_amount_value"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Data de Aquisição:"
                  v-mask-date.br
                  v-model="data.vehicle_date_acquisition"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Data de Encerramento:"
                  v-mask-date.br
                  v-model="data.vehicle_date_closure"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Data do ultimo registro do TCE:"
                  v-mask-date.br
                  v-model="data.vehicle_date_last_tce_record"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Ultimo KM/Hora Enviado:"
                  v-mask-decimal.br="2"
                  v-model="data.vehicle_last_kmh"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  label="Valor atual do veículo:"
                  v-mask-decimal.br="2"
                  v-model="data.vehicle_current_value"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-autocomplete
                  label="Vinculo:"
                  :rules="fieldRules"
                  :items="bonds"
                  item-value="bond_id"
                  item-text="bond_desc"
                  v-model="data.bond_id"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-autocomplete
                  label="Configuraçōes de Faturamento:"
                  :items="billings"
                  v-model="data.billing_type"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-autocomplete
                  label="Atendimento:"
                  :rules="fieldRules"
                  :items="attendances"
                  item-value="attendance_id"
                  item-text="attendance_desc"
                  v-model="data.attendance_id"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-autocomplete
                  label="Proprietário do Veículo:"
                  :items="proprietario"
                  item-value="id"
                  item-text="name"
                  v-model="data.vehicle_proprietario"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-autocomplete
                  label="Locador ou Prestador de Serviço:"
                  :items="locador"
                  item-value="id"
                  item-text="name"
                  v-model="data.vehicle_locador"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-select
                  label="Categoria do Veiculo:"
                  :items="[
                    { text: 'Veiculo', value: 1 },
                    { text: 'Maquina', value: 2 },
                  ]"
                  item-value="value"
                  item-text="text"
                  v-model="data.vehicle_categoria"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  name="input-7-4"
                  label="Descrição da máquina"
                  v-model="data.vehicle_observations"
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-checkbox v-model="data.vehicle_reports" label="Relatórios" />
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-checkbox
                  v-model="data.vehicle_hodometro"
                  label="Hodômetro"
                />
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-checkbox
                  v-model="data.vehicle_horimetro"
                  label="Horímetro"
                />
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-checkbox
                  v-model="data.vehicle_active"
                  label="Veículo Ativo"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-footer style="padding: 10px">
        <v-spacer />
        <v-btn
          :disabled="!valid && loader"
          depressed
          large
          color="primary"
          class="mr-4"
          :loading="loader"
          @click="validate"
          >Confirmar</v-btn
        >
      </v-footer>
    </v-card>
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  props: ["id"],
  data: () => ({
    valid: false,
    loader: false,
    prefectures: [],
    secretariats: [],
    subsectors: [],
    brands: [],
    models: [],
    colors: [],
    fuels: [],
    consumption: [],
    billings: ["POR VEICULO", "POR SECRETARIA"],
    bonds: [],
    attendances: [],
    proprietario: [],
    locador: [],
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    data: {
      vehicle_id: null,
      prefecture_id: null,
      sec_id: null,
      subsec_id: null,
      model_id: null,
      brand_id: null,
      color_id: null,
      fuel_id: null,
      consumption_id: null,
      bond_id: null,
      billing_type: "",
      attendance_id: null,
      vehicle_board: null,
      vehicle_manufacturing_year: null,
      vehicle_model_year: null,
      vehicle_tank_capacity: 0.0,
      vehicle_average_consumption_minimum: 0.0,
      vehicle_average_consumption_maximum: 0.0,
      vehicle_consumption_liters_maximum: 0.0,
      vehicle_consumption_liters_hour: 0.0,
      vehicle_number_of_liters: 0.0,
      vehicle_amount_value: 0.0,
      vehicle_date_acquisition: null,
      vehicle_date_closure: null,
      vehicle_date_last_tce_record: null,
      vehicle_last_kmh: 0.0,
      vehicle_current_value: 0.0,
      vehicle_observations: null,
      vehicle_reports: null,
      vehicle_hodometro: null,
      vehicle_horimetro: null,
      vehicle_active: null,
      vehicle_renavan: "",
      vehicle_proprietario: null,
      vehicle_locador: null,
      vehicle_cod: null,
      vehicle_cod_maquina: null,
      vehicle_categoria: null,
    },
    prefecture_id: null,
  }),
  created() {
    this.$http.get("prefectures").then((r) => (this.prefectures = r.data));
    this.$http.get("proprietario").then((r) => (this.proprietario = r.data));
    this.$http.get("locador").then((r) => (this.locador = r.data));
    this.$http
      .get("/vehicles/brands")
      .then(
        (r) =>
          (this.brands = r.data.filter(
            (i) => i.brand_num !== null && i.brand_num !== ""
          ))
      );
    this.$http
      .get("/vehicles/models")
      .then(
        (r) =>
          (this.models = r.data.filter(
            (i) => i.model_num !== null && i.model_num !== ""
          ))
      );
    this.$http.get("/vehicles/colors").then((r) => (this.colors = r.data));
    this.$http.get("/settings/fuels").then((r) => (this.fuels = r.data));
    this.$http.get("/settings/bonds").then((r) => (this.bonds = r.data));
    this.$http
      .get("/settings/consumption")
      .then((r) => (this.consumption = r.data));
    this.$http
      .get("/settings/attendance_types")
      .then((r) => (this.attendances = r.data));

    if (this.id) {
      this.$store.dispatch("setLoader", true);
      this.$http.get(`/vehicles/${this.id}`).then((r) => {
        this.prefecture_id = r.data[0].prefecture_id;
        this.data = r.data[0];
        r.data[0].vehicle_average_consumption_maximum =
          r.data[0].vehicle_average_consumption_maximum.toFixed(2);
        r.data[0].vehicle_average_consumption_minimum =
          r.data[0].vehicle_average_consumption_minimum.toFixed(2);
        r.data[0].vehicle_consumption_liters_hour =
          r.data[0].vehicle_consumption_liters_hour.toFixed(2);
        r.data[0].vehicle_consumption_liters_maximum =
          r.data[0].vehicle_consumption_liters_maximum.toFixed(2);
        r.data[0].vehicle_tank_capacity =
          r.data[0].vehicle_tank_capacity.toFixed(2);

        r.data[0].vehicle_current_value =
          r.data[0].vehicle_current_value.toFixed(2);

        r.data[0].vehicle_amount_value =
          r.data[0].vehicle_amount_value.toFixed(2);
        r.data[0].vehicle_number_of_liters =
          r.data[0].vehicle_number_of_liters.toFixed(2);

        this.data.vehicle_date_acquisition =
          this.data.vehicle_date_acquisition &&
          this.convertDate(r.data[0].vehicle_date_acquisition);
        this.data.vehicle_date_closure =
          this.data.vehicle_date_closure &&
          this.convertDate(r.data[0].vehicle_date_closure);
        this.data.vehicle_date_last_tce_record =
          this.data.vehicle_date_last_tce_record &&
          this.convertDate(r.data[0].vehicle_date_last_tce_record);

        delete this.data.created_at;
        this.$store.dispatch("setLoader", false);
        this.selectSecretariats(this.data.prefecture_id);
        this.selectSubSectors(this.data.sec_id);
      });
    }
  },
  methods: {
    validate() {
      this.snack.show = true;
      this.loader = true;
      if (this.$refs.form.validate()) {
        this.createOrUpdate();
      } else {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message =
          "Atencão um ou mais campos precisam ser preenchidos!";
        this.loader = false;
      }
    },
    selectSecretariats(id) {
      this.$store.dispatch("setLoader", true);
      this.$http.get(`/prefectures/secretariats/${id}`).then((r) => {
        this.secretariats = r.data;
        this.$store.dispatch("setLoader", false);
      });
    },
    selectSubSectors(id) {
      this.$http.get(`/prefectures/subsectors/${id}`).then((r) => {
        this.subsectors = r.data;
      });
    },
    convertDate(v) {
      if (v) {
        v = v.replace("-", "").replace("-", "");
        let year = v.substring(0, 4);
        let month = v.substring(4, 6);
        let day = v.substring(6, 8);
        return `${day}/${month}/${year}`;
      } else {
        return false;
      }
    },
    createOrUpdate() {
      this.loader = true;
      if (this.id) {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .put(`/vehicles/${this.id}`, this.data)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.loader = true;
            setTimeout(() => {
              this.$router.push(`/vehicles-manager/${this.prefecture_id}`);
            }, 1500);
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      } else {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .post("/vehicles", this.data)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            this.loader = false;
            this.$store.dispatch("setLoader", this.loader);
            setTimeout(() => {
              this.$router.push("/vehicles-manager");
            }, 1500);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      }
    },
    getModelText(item) {
      return `${item.model_desc} - ${item.model_num}`;
    },
    getBrandText(item) {
      return `${item.brand_desc} - ${item.brand_num}`;
    },
  },
};
</script>

<style>
.title {
  text-transform: uppercase;
  font-weight: 400;
}

.flexd {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.flexd p {
  margin: 10px 0;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
